import { OrderType } from '../../config/constants';

type PendingOrderStatus = Extract<OrderType['status'], 'pending' | 'requested'>;

const isPendingOrder = (status: OrderType['status']): status is PendingOrderStatus => {
    return ['pending', 'requested'].includes(status);
};

export default isPendingOrder;
